import React, { useEffect, useState } from 'react';
import { Sparkles, Loader2, Send, MailCheck, RefreshCw } from 'lucide-react';
import { toast } from 'sonner';
import { productsAPI } from '../services/api';

const fmt = (iso) => (iso ? new Date(iso).toLocaleDateString('fr-FR', { day: '2-digit', month: 'short' }) : '—');

// Admin card: weekly « Nouveautés » e-mail subscriptions (per category) + send now / send me a test
const AdminNewArrivalsSubsCard = () => {
  const [stats, setStats] = useState(null);
  const [busy, setBusy] = useState('');
  const load = () => productsAPI.adminSubsStats().then(setStats).catch(() => setStats({ error: true }));
  useEffect(() => { load(); }, []);
  if (!stats || stats.error) return null;

  const sendNow = async () => {
    if (!window.confirm(`Envoyer maintenant les nouveautés de la semaine aux ${stats.active} abonné(s) ?`)) return;
    setBusy('send');
    try { const r = await productsAPI.adminSubsSend(); toast.success(`${r.sent} e-mail(s) envoyé(s) · ${r.no_news} abonné(s) sans nouveauté`); load(); } catch (e) { toast.error(e.response?.data?.detail || "Échec de l'envoi"); } finally { setBusy(''); }
  };
  const sendTest = async () => {
    setBusy('test');
    try { const r = await productsAPI.adminSubsTest(); toast.success(`E-mail de test envoyé à ${r.sent_to}`); } catch (e) { toast.error(e.response?.data?.detail || "Échec de l'envoi du test"); } finally { setBusy(''); }
  };

  return (
    <div className="bg-white rounded-xl shadow-sm p-5 mb-6" data-testid="admin-new-arrivals-subs-card">
      <div className="flex flex-wrap items-center justify-between gap-3 mb-4">
        <h2 className="text-lg font-bold text-gray-900 flex items-center gap-2"><Sparkles className="text-orange-500" size={20} /> Abonnés « Nouveautés de la semaine »</h2>
        <div className="flex flex-wrap items-center gap-2">
          <button type="button" onClick={load} className="text-xs text-gray-500 hover:text-gray-900 inline-flex items-center gap-1" data-testid="new-subs-refresh"><RefreshCw size={12} /> Actualiser</button>
          <button type="button" onClick={sendTest} disabled={!!busy} data-testid="new-subs-test" className="inline-flex items-center gap-1.5 rounded-md border border-gray-300 text-gray-700 text-xs font-semibold px-3 py-1.5 hover:bg-gray-50 disabled:opacity-50">{busy === 'test' ? <Loader2 size={12} className="animate-spin" /> : <MailCheck size={12} />} M'envoyer un test</button>
          <button type="button" onClick={sendNow} disabled={!!busy || !stats.active || !stats.products_week} data-testid="new-subs-send" className="inline-flex items-center gap-1.5 rounded-md bg-[#1e3a5f] text-white text-xs font-semibold px-3 py-1.5 hover:bg-[#2d4a6f] disabled:opacity-50">{busy === 'send' ? <Loader2 size={12} className="animate-spin" /> : <Send size={12} />} Envoyer maintenant</button>
        </div>
      </div>
      <div className="grid grid-cols-2 md:grid-cols-4 gap-3 mb-3">
        {[['Abonnés actifs', stats.active, 'new-subs-active'], ['Désabonnés', stats.cancelled, 'new-subs-cancelled'], ['E-mails envoyés', stats.emails_sent, 'new-subs-emails'], ['Pièces cette semaine', stats.products_week, 'new-subs-products']].map(([l, v, id]) => (
          <div key={id} className="rounded-lg border border-gray-100 bg-gray-50 px-3 py-2"><p className="text-[11px] uppercase tracking-wide text-gray-500">{l}</p><p className="text-xl font-bold text-gray-900" data-testid={id}>{v}</p></div>
        ))}
      </div>
      <p className="text-xs text-gray-500 mb-3">Envoi automatique le lundi matin (cron « daily-morning », étape « weekly-new-arrivals »). Dernier envoi : {fmt(stats.last_run?.at)}{stats.last_run?.result ? ` — ${stats.last_run.result.sent} e-mail(s)` : ''}.</p>
      {stats.by_category.length > 0 && (
        <div className="flex flex-wrap gap-2" data-testid="new-subs-by-category">
          {stats.by_category.map((c) => <span key={c.category || 'all'} className="text-xs bg-orange-50 text-orange-800 border border-orange-100 rounded-full px-2.5 py-1">{c.name} · <strong>{c.count}</strong></span>)}
        </div>
      )}
    </div>
  );
};

export default AdminNewArrivalsSubsCard;
